import { FormEvent, useState } from "react";
import { Auth } from "aws-amplify";
import { Link, useNavigate } from "react-router-dom";

import { Image } from "components/atoms";
import { AuthForm } from "components/molecules";

import authFormBg from "assets/images/authFormBg.png";
import logo from "assets/images/logo.svg";
import { BackgroundImageSize } from "interfaces/images";

const SignUp = (): JSX.Element => {
	const [login, setLogin] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const navigate = useNavigate();

	const handleChangeLogin = (value: string | number) => {
		setLogin(`${value}`);
	};

	const handleChangePassword = (value: string | number) => {
		setPassword(`${value}`);
	};

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();

		try {
			setIsLoading(true);

			await Auth.signUp({
				attributes: {
					email: login,
				},
				username: login.replace("@", "."),
				password,
			});

			setIsLoading(false);

			navigate("/");
		} catch (error) {
			console.log({ error });
			setIsLoading(false);
		}
	};

	return (
		<div className="grid grid-cols-[0.55fr_0.45fr] w-full h-full items-center">
			<Image
				src={authFormBg}
				isBackground
				backgroundSize={BackgroundImageSize.COVER}
			/>
			<div className="flex justify-center items-center flex-col w-full">
				<div className="w-[364px]">
					<div className="mb-16 flex justify-center h-[70px] brightness-0 invert">
						<Image src={logo} width={312} />
					</div>
					<AuthForm
						login={login}
						password={password}
						changeLogin={handleChangeLogin}
						changePassword={handleChangePassword}
						submit={handleSubmit}
						isLoading={isLoading}
						submitTitle="Sign Up"
					/>
					<div className="flex justify-center pt-6 w-full">
						<Link
							to="/"
							className="text-muted-foreground no-underline text-sm transition-colors hover:text-foreground"
						>
							Go to Sign In
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SignUp;
